import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { queryKeys } from '@/queries/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/** PUT `/admin/passwordChange/{newPassword}` — updates password for signed-in user. */
export function usePasswordChangeMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    (newPassword) => `/admin/passwordChange/${encodeURIComponent(newPassword)}`,
    'put',
    {},
    {
      onSuccess: (data) => {
        if (data?.accountName) {
          useAuthStore.getState().setSession(data);
        }
        queryClient.invalidateQueries({ queryKey: queryKeys.session() });
        NotificationManager.success('Password changed', '', 3000);
      },
      onError: (err) => {
        NotificationManager.error(
          err.message || 'Could not change password',
          '',
          4000,
        );
      },
    },
  );
}
